/** 与 backend/utils/order/orderPrimaryPhase.js 展示一致 */
import { PENDING_TAB_BADGE } from '../../../../dashboard/processing-order/common/pendingTableConfig';
import { ORDER_APPROVAL_STATUS_APPROVED_VALUES } from '../../../../../utils/order/orderStatus';

export const DEFAULT_ORDER_PRIMARY_PHASE_LENS = 'operational';

/** 订单行主阶段（V1 仅 operational） */
export const getOrderStatisticsPrimaryPhase = (order) => order?.primaryPhases?.[DEFAULT_ORDER_PRIMARY_PHASE_LENS] ?? null;

/** stats / compare 上的 lenses.operational */
export const getStatisticsLensData = (container) => container?.lenses?.[DEFAULT_ORDER_PRIMARY_PHASE_LENS] ?? null;

/** colorType 与待办 tab 行主题色（pendingTableConfig.PENDING_TAB_BADGE）一致 */
export const ORDER_PRIMARY_PHASE_META = [
	{ phase: 'pendingApproval', label: '审批中', colorType: PENDING_TAB_BADGE.approving },
	{ phase: 'approvalRejected', label: '审批驳回', colorType: PENDING_TAB_BADGE.applying },
	{ phase: 'waitingPrepay', label: '待预付', colorType: PENDING_TAB_BADGE.prePayment },
	{ phase: 'waitingDelivery', label: '待发货', colorType: PENDING_TAB_BADGE.delivering },
	{ phase: 'waitingAccept', label: '待验收', colorType: PENDING_TAB_BADGE.accepting },
	{ phase: 'collecting', label: '收款中', colorType: PENDING_TAB_BADGE.accountsReceivable },
	{ phase: 'pendingReview', label: '待核验', colorType: PENDING_TAB_BADGE.finalCostVerification },
	{ phase: 'completed', label: '已完成', colorType: 'success' },
];

/**
 * 经营总览 KPI 合同金额/单数同比环比：仅两种口径可比。
 * - 下单：无流程节点收窄，且审批仅为通过（approved + systemApproved）
 * - 完成：流程节点仅为已完成（completed）
 * 其它流程卡点、审批中/驳回、物流/财务原始状态筛选 → 不可比，关闭 KPI 对比。
 */
export const OVERVIEW_KPI_COMPARE_COMPLETED_PHASE = 'completed';

const isApprovedOnlyApprovalFilter = (approvalStatuses) => {
	const statuses = Array.isArray(approvalStatuses) ? approvalStatuses.filter(Boolean) : [];
	if (statuses.length === 0) return false;
	return statuses.every((status) => ORDER_APPROVAL_STATUS_APPROVED_VALUES.includes(status));
};

const isCompletedOnlyPhaseFilter = (primaryPhases) => {
	const phases = Array.isArray(primaryPhases) ? primaryPhases.filter(Boolean) : [];
	if (phases.length === 0) return false;
	return phases.every((phase) => phase === OVERVIEW_KPI_COMPARE_COMPLETED_PHASE);
};

/** @returns {'order'|'completed'|null} 当前筛选下 KPI 可比口径；不可比返回 null */
export const resolveOverviewKpiCompareMode = (filters = {}) => {
	if ((filters.paymentStatuses?.length ?? 0) > 0) return null;
	if ((filters.deliveryStatuses?.length ?? 0) > 0) return null;

	const phases = Array.isArray(filters.primaryPhases) ? filters.primaryPhases.filter(Boolean) : [];
	if (phases.length > 0) {
		return isCompletedOnlyPhaseFilter(phases) ? 'completed' : null;
	}

	return isApprovedOnlyApprovalFilter(filters.approvalStatuses) ? 'order' : null;
};

/** 非下单/完成口径时抑制经营总览 KPI 同比/环比 */
export const shouldSuppressOverviewKpiCompareForFilters = (filters = {}) => resolveOverviewKpiCompareMode(filters) == null;

/** 流程分布链路不展示：审批态由顶栏审批筛选覆盖 */
export const PROCESS_DISTRIBUTION_EXCLUDED_PHASES = new Set(['pendingApproval', 'approvalRejected']);

export const ORDER_PRIMARY_PHASE_FLOW_META = ORDER_PRIMARY_PHASE_META.filter(({ phase }) => !PROCESS_DISTRIBUTION_EXCLUDED_PHASES.has(phase));

export const getOrderPrimaryPhaseColorType = (phase) => ORDER_PRIMARY_PHASE_META.find((item) => item.phase === phase)?.colorType ?? 'secondary';

export const getOrderPrimaryPhaseThemeColor = (phase, getThemeColor) => getThemeColor(getOrderPrimaryPhaseColorType(phase));

export const getOrderPrimaryPhaseLabel = (phase) => ORDER_PRIMARY_PHASE_META.find((item) => item.phase === phase)?.label ?? phase ?? '-';

/** 列表/Modal 状态徽章：固定物流轨（delivery） */
export const ORDER_PRIMARY_PHASE_BADGE_TRACK = 'delivery';

export const getOrderPrimaryPhaseViewPriorityBadge = (order) => order?.statusBadges?.[ORDER_PRIMARY_PHASE_BADGE_TRACK] ?? null;
